/**
 * PORT-005 §5.2 — **la ligne 2 d'un espace (« pour qui ») ne se coupe JAMAIS : elle passe à la ligne.**
 *
 * Son seul porteur d'affichage, pour les quatre surfaces qui la rendent : la page de choix, le
 * sélecteur de l'en-tête (menu de bureau et volet bas), l'en-tête lui-même et la carte « Espace
 * par défaut » de « Mon compte ». Le texte vient de `ligneDeuxDuContexte` (`contextKind.ts`).
 *
 * 🔴 **Pourquoi pas `truncate`** : c'est la ligne qui DÉPARTAGE deux espaces, et ce qui les
 * départage s'écrit à sa FIN. Deux magasins d'une même enseigne dans la même ville se lisent
 * « INTERMARCHE (Lorient, 12 rue du Port) · … » et « INTERMARCHE (Lorient, CLI-0000042) · … »
 * (décision du PO du 2026-10-08, `infra/portal_grants_repository/_homonymes.py`) : coupée à une
 * ligne, la rue ou la référence tombait sous les points de suspension et les deux cartes se
 * relisaient pareil. Mesuré sur l'annuaire réel (253 groupes « même enseigne », 1 100 lignes, la
 * personne contact de tous les magasins du groupe) : à 33 caractères par ligne (téléphone),
 * 77 lignes restaient jumelles à l'écran sous `truncate` ; à 29 caractères, 13 encore sous
 * `line-clamp-2`. Sans coupe, aucune — par construction. Le prix, là seulement où le nom est
 * long : à 29 caractères par ligne, deux ou trois lignes de `text-xs` pour 1 017 de ces 1 100
 * lignes, quatre pour 78, cinq pour 5 (un organisme au nom long en ajoute une ou deux).
 *
 * ⛔ Ni `truncate`, ni `line-clamp-*`, ni un parent en `whitespace-nowrap` (`<Button>` en porte
 * un : la ligne n'entre jamais dans un `Button`). `break-words` coupe un mot plus large que la
 * carte au lieu de le laisser déborder sur le chevron. Gardé par
 * `__tests__/laLigneQuiDepartageDeuxEspacesNeSeCoupeJamais.test.tsx`.
 */
import { cn } from '@/lib/utils'

export function LigneDeuxDeLEspace({ texte, className }: { texte: string; className?: string }) {
    return <span className={cn('block break-words text-xs text-muted-foreground', className)}>{texte}</span>
}
